import { render, staticRenderFns } from "./HotsRank.vue?vue&type=template&id=6d321c8e&scoped=true&lang=true&"
import script from "./HotsRank.vue?vue&type=script&lang=js&"
export * from "./HotsRank.vue?vue&type=script&lang=js&"
import style0 from "./HotsRank.vue?vue&type=style&index=0&id=6d321c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d321c8e",
  null
  
)

export default component.exports